import { Directive, Input, TemplateRef } from '@angular/core';

export interface FilterableListItemContext<T extends string | object> {
  $implicit: T;
  itemsFilter: string;
}

@Directive({
  selector: 'ng-template[y42FilterableListItem]',
})
export class FilterableListItemDirective<T extends string | object> {
  constructor(public template: TemplateRef<FilterableListItemContext<T>>) {}

  @Input('y42FilterableListItem') listItems!: T[];

  static ngTemplateContextGuard<T extends string | object>(
    dir: FilterableListItemDirective<T>,
    ctx: unknown,
  ): ctx is FilterableListItemContext<T> {
    return true;
  }
}
